import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["stretching-before-running"]!;

export function Body() {
  return (
    <>
      <p>
        Many runners learned to stretch before a run. Others have heard that stretching makes
        you slower. A review from 2016 looked at what stretching before exercise actually does.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers from Canada, Australia, the UK and the US reviewed studies of three kinds of
        stretching before exercise: static stretching, where you hold a position; dynamic
        stretching, where you move through a range of motion; and a form of contract-relax
        stretching. They looked at performance, range of motion and injuries.
      </p>

      <h2>What they found</h2>
      <p>
        When performance was tested right after stretching, static stretching lowered it by 3.7
        percent on average, and contract-relax stretching by 4.4 percent. Dynamic stretching
        improved it by 1.3 percent.
      </p>
      <p>
        The effect of static stretching depended on how long it was held. Stretching each muscle
        group for 60 seconds or more lowered performance by 4.6 percent, while less than 60
        seconds lowered it by 1.1 percent. When the stretching was followed by more dynamic
        movement before the test, there was no clear effect on performance.
      </p>
      <p>
        Static and contract-relax stretching had no clear effect on injuries overall. Range of
        motion improved with all types, but usually for less than 30 minutes.
      </p>

      <h2>What it means for you</h2>
      <p>
        A good warm-up for running is easy running followed by some dynamic movement, such as
        leg swings, skips and a few strides. If you like to stretch, keep it short and finish
        with movement before you run hard.
      </p>
      <p>
        Long static stretches are better saved for after the run or a separate time, if you
        want to improve your flexibility.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        Most studies tested strength, jumps or sprints a few minutes after stretching, not
        running performance over longer distances. There was no injury data for dynamic
        stretching.
      </p>

      <h2>How we use it</h2>
      <p>
        Sessions in PX7 Training include a warm-up of easy running before the harder work, and
        strides where they fit the purpose of the session.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Behm et al. (2016), Acute effects of muscle stretching on physical performance, range
          of motion, and injury incidence in healthy active individuals: a systematic review.{" "}
          <a href="https://doi.org/10.1139/apnm-2015-0235">Applied Physiology, Nutrition, and Metabolism</a>.
        </li>
      </ul>
    </>
  );
}
